import { apiGetRequest } from '../../../../utils/api/get';
import { VendorListResponse } from '../../model/vendor';
import { BASE_URL } from '../../../../utils/auth';

export const fetchVendorListAPI = (token: string): Promise<VendorListResponse> =>
  apiGetRequest<VendorListResponse>({
    apiUrl: `${BASE_URL}/users/get-all-users`,
    token,
    params: { status: '', userType: 'vendor' },
  });
